var render, staticRenderFns
import script from "./form-copy.vue?vue&type=script&lang=js&"
export * from "./form-copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e333581e')) {
      api.createRecord('e333581e', component.options)
    } else {
      api.reload('e333581e', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/treety/modules/form/form-copy.vue"
export default component.exports